import React from 'react'
//import { CardMedia } from '@material-ui/core'
//import Card from '@material-ui/core/Card'
//import ReactPlayer from 'react-player/youtube'


function StoryVideoAsset(asset) {
  return <div key={asset.id} />
}

export default StoryVideoAsset
